<template>
	<vx-card :title="$t('Follower.RecipientSettingsSmsOrWhatsApp')" card-border no-shadow id="cell_phone-settings">
		<p>{{ $t("Follower.RecipientSettingsSmsOrWhatsAppText") }}</p>

		<!-- Append Button -->

		<div>
			<label class="vs-input--label">{{ $t("Country") }}</label>
			<v-select
				class="w-full"
				v-model="selectedCountry"
				:options="dataCountries"
				:clearable="false"
				:closeOnSelect="true"
			/>
		</div>

		<label class="vs-input--label" for="email">{{ $t("Phone") }}</label>

		<vx-input-group class="mb-2">
			<vs-input type="phone" v-model="phone" id="cell_phone" name="cell_phone" @keypress.enter="addPhone" />
			<template slot="append">
				<div class="append-text btn-addon">
					<vs-button icon-pack="feather" icon="icon-plus" @click="addPhone" :disabled="errors.has('email')"
						>{{ $t("Add") }}
					</vs-button>
				</div>
			</template>
		</vx-input-group>

		<p class="text-base mt-base">{{ $t("Follower.RecipientSettingsSmsOrWhatsAppPlaceholderList") }}</p>

		<vs-divider></vs-divider>

		<vs-list v-if="phones.length">
			<vs-list-item v-for="(phone, index) in phones" :key="index" icon-pack="feather" icon="icon-phone">
				<template slot="title">
					<div @click="action('select', index)" class="ml-2 p-2">
						<p>{{ phone }}</p>
					</div>
				</template>

				<feather-icon
					:title="$t('Copy')"
					icon="CopyIcon"
					v-clipboard:copy="phone"
					v-clipboard:success="onCopy"
					v-clipboard:error="onError"
					svgClasses="h-5 w-5 hover:text-primary cursor-pointer"
					class="mr-4"
				/>

				<feather-icon
					:title="$t('Crud.Delete')"
					icon="Trash2Icon"
					svgClasses="h-5 w-5 hover:text-danger cursor-pointer"
					@click="removePhone(index)"
				/>
			</vs-list-item>
		</vs-list>

		<vs-alert icon-pack="feather" icon="icon-phone" color="warning" :active="phones.length === 0" class="w-full">
			{{ $t("Follower.NoCellPhonesYet") }}
		</vs-alert>
	</vx-card>
</template>

<script>
import vSelect from "vue-select";
import countries from "./countries";
import Follower from "../../models/Follower";

export default {
	name: "FollowerFormPhone",
	components: {
		// component components
		vSelect,
	},
	props: {
		phones: {
			type: Array,
			required: true,
		},
	},
	data() {
		return {
			// component dat
			phone: "",
			selectedCountry: {
				value: "+57",
				label: "🇨🇴 CO (+57)",
			},
			follower: new Follower({}),
		};
	},
	computed: {
		// component computed properties
		dataCountries() {
			return countries.map(({code, code_num, flag_emoji}) => ({
				value: code_num,
				label: `${flag_emoji} ${code.toUpperCase()} (${code_num})`,
			}));
		},
	},
	methods: {
		// component methods
		addPhone() {
			this.$emit("add", this.phone, this.selectedCountry.value);
			this.phone = "";
		},
		onCopy(e) {
			const {text} = e;
			const {prefix, number, country} = this.follower.splitNumber(text);
			const c = countries.find((c) => c.code_num === prefix);
			const flag = c ? c.flag_emoji : "🌐";
			this.phone = number;
			this.selectedCountry = {
				value: prefix,
				label: `${flag} ${country} (${prefix})`,
			};

			this.$vs.notify({
				title: this.$t("Follower.cell_phone"),
				text: this.$t("CopiedToClipboard"),
				color: "success",
				iconPack: "feather",
				position: "top-center",
				icon: "icon-check-circle",
			});
		},
		onError() {
			this.$vs.notify({
				title: this.$t("Followers.phone"),
				text: this.$t("CopiedError"),
				color: "danger",
				iconPack: "feather",
				position: "top-center",
				icon: "icon-alert-circle",
			});
		},

		removePhone(index) {
			this.$emit("remove", index);
		},
	},
};
</script>

<style scoped>
/* component styles */
</style>
